import React ,{ useState ,useEffect}from 'react';
import { Link } from "react-router-dom";
import Axios from 'axios';
import TabsComp from '../Shared/TabsComp';
import Tab from 'react-bootstrap/Tab';
import Table from "../Shared/Table";
import Pie from "../Shared/Pie";
import GraphsCard from "./GraphsCard";
import ActionGraph from "../Shared/ActionGraph";
import MultiBar from "../Shared/MultiBar";

import Config  from "../Helpers/Config";
import Helpers from "../Helpers/Custom";
import Loader from "../../utils/Loader";

function PvtInvestment({payload}) {
    const [mode, setMode] = useState("investedCapital");
    const [data, setData] = useState({});
    const [kpiTrends, setKpiTrends] = useState({});
    const [kpiTrendsLatest, setKpiTrendsLatest] = useState({});
    const [kpiTrendsByYear, setKpiTrendsByYear] = useState({});
    const [kpiTrendsYears, setKpiTrendsYears] = useState({});
    const [graphData, setGraphData] = useState({});
    const [pieData, setPieData] = useState({});
    const [kpRegister, setKpRegister] = useState({});
    const [loading, setsLoading] = useState(false);

    useEffect(() => {
        fetchDetails();
     }, [payload]);

     const fetchDetails = ()=>{
        setsLoading(true)
        Axios.get(Config.api("api/portfolio/valuation/private"),{
            params:payload
        })
        .then( (response) => {
            var data  = response.data;
            var lclgraphYears = [];
            var lclkpRegister = [];

            if(data?.extras?.kpiTrend){
                data?.extras?.kpiTrend.forEach((list,i)=>{
                    lclgraphYears.push(Helpers.getMonth(list?.first)+"-"+Helpers.getYear(list?.first))
                })
            }

     
            if(data?.extras?.kpRegister){
                data?.extras?.kpRegister.forEach((list,i)=>{
                    var obj = {}
                    var inData = []
                    obj.name = list?.investment?.name;
                    obj.totalValue = list?.totalValue;
                    inData.push(list?.investedCapital ?? 0,list?.totalValue ?? 0,list?.valueCreated ?? 0,list?.marketValue ?? 0);
                    obj.data = inData;
                    lclkpRegister.push(obj)
                })
            }
      


            setKpiTrends(data?.extras?.kpiTrend);
            setKpiTrendsLatest(data?.extras?.kpiTrend?.slice(-1).pop()?.second);
            setKpiTrendsYears(lclgraphYears);
            setPieData(data?.extras?.allocation?.map(x=>({"name":x.key.name,"y": x.value})) ?? {});
            setKpRegister(lclkpRegister);
            setData(data)
            changeMode(null,data?.extras?.kpiTrend);
            setsLoading(false)
        })
        .catch((err) => {
            setsLoading(false)
        });
   }


    const changeMode = (e,kpiData)=>{
        
        let lclMode = e?.currentTarget?.dataset?.name ?? "investedCapital";
       
        var investedCapital = []
        var marketValue = []
        var valueCreated = []
        var totalValue = []
        var netIrr = []
        var kpiTrendsByYearLcl = {}

        var dataset = !Helpers.isEmpty(kpiTrends) ?  kpiTrends : kpiData ;

       
       
        if(!Helpers.isEmpty(dataset)){
            dataset.forEach((list,i)=>{
                investedCapital.push(list?.second?.investedCapital ?? 0)
                marketValue.push(list?.second?.marketValue ?? 0)
                valueCreated.push(list?.second?.valueCreated ?? 0)
                totalValue.push(list?.second?.totalValue ?? 0)
                netIrr.push(list?.second?.netIrr ?? 0)
            });
        };
   
        kpiTrendsByYearLcl.investedCapital = investedCapital;
        kpiTrendsByYearLcl.marketValue = marketValue;
        kpiTrendsByYearLcl.valueCreated = valueCreated;
        kpiTrendsByYearLcl.totalValue = totalValue;
        kpiTrendsByYearLcl.netIrr = netIrr;


         setKpiTrendsByYear(kpiTrendsByYearLcl[lclMode]);
         setMode(lclMode)
    }


    return (
        <div className="mt-5 mb-3">
        <h5 className="heading border-0">PRIVATE INVESTMENT DETAILS</h5>
        <TabsComp defaultActiveKey="position" id="privateInvestmentt">
            <Tab eventKey="position" title="Position" className="custom-tab-content">
                <Table>
                    <thead>
                        <tr>
                            <th rowSpan="2">Description</th>
                            <th rowSpan="2" className="br-bold">Ccy</th>
                            <th colSpan="9" className="yellowBg br-bold">In Valuation Ccy</th>
                            <th rowSpan="2"></th>
                        </tr>
                        <tr>
                            <th className="subTh bl-bold">Invested Capital</th>
                            <th className="subTh">Distribution</th>
                            <th className="subTh">Market Value</th>
                            <th className="subTh">Total Value</th>
                            <th className="subTh">Value Created</th>
                            <th className="subTh">Unrealized Gain/Loss</th>
                            <th className="subTh">Net IRR</th>
                            <th className="subTh">Net Multiple</th>
                            <th className="subTh br-bold">Since</th>
                        </tr>
                    </thead>
                    <tbody>
                    { 
                                data && data.rows ? data.rows.map((row,i)=>(
                                    <React.Fragment>
                                        <tr className="bg-gray" key={"row"+i}>
                                            <td colSpan="12">{row?.currency?.name}</td>
                                        </tr>
                                    
                                        {
                                            row?.rows.map((list,i)=>(
                                                <tr className="" key={"childrow"+i}>
                                                    <td>{list?.investment.name}</td>
                                                    <td>{row.currency.name}</td>
                                                    <td  className="text-right">{Helpers.amountFormat(list?.investedCapital ?? 0)}</td>
                                                    <td  className="text-right">{Helpers.amountFormat(list?.distribution ?? 0)}</td>
                                                    <td  className="text-right">{Helpers.amountFormat(list?.marketValue ?? 0)}</td>
                                                    <td  className="text-right">{Helpers.amountFormat(list?.totalValue ?? 0)}</td>
                                                    <td  className="text-right">{Helpers.amountFormat(list?.valueCreated ?? 0)}</td>
                                                    <td  className="text-right"> {list?.unrealizedGainLoss ? Helpers.amountFormat(list?.unrealizedGainLoss ?? 0) : ""}</td>
                                                    <td  className="text-right">{list?.netIrr ? Helpers.formatNumberComma(list?.netIrr)+"%" : "0%"}</td>
                                                    <td  className="text-right">{Helpers.formatNumberComma(list?.netMultiple ?? 0)}</td>
                                                    <td  className="text-right">{list?.since ? Helpers.getDateInInputFormat(list.since) : "-"}</td>
                                                    <td>
                                                         <Link to={"/transaction/private?id="+list?.investment?.id} state={{ payload: payload,id:list?.investment?.id}}>{<i class="fa fa-bars"></i>}</Link>
                                                    </td>

                                                </tr>
                                            ))
                                        }
                                    </React.Fragment>
                                ))
                                :
                                <tr>
                                    <td colspan="20">No data found</td>
                                </tr>
                            }
                             {data?.totalRow && 
                                <tr>
                                <td colSpan="12" className="emptyRow"></td>
                               </tr>}
                            {data?.totalRow && 
                            <tr>
                            <td colSpan="12" className="emptyRow"></td>
                            </tr>}
                            
                    </tbody>

                    {data?.totalRow && <tfoot>
                           <tr>
                                <td className="text-right"></td>
                                <td className="text-right"></td>
                                <td className="text-right">{Helpers.amountFormat(data?.totalRow?.investedCapital ?? 0)}</td>
                                <td className="text-right">{Helpers.amountFormat(data?.totalRow?.distribution ?? 0)}</td>
                                <td className="text-right">{Helpers.amountFormat(data?.totalRow?.marketValue ?? 0)}</td>
                                <td className="text-right">{Helpers.amountFormat(data?.totalRow?.totalValue ?? 0)}</td>
                                <td className="text-right">{Helpers.amountFormat(data?.totalRow?.valueCreated ?? 0)}</td>
                                <td className="text-right">{Helpers.amountFormat(data?.totalRow?.unrealizedGainLoss ?? 0)}</td>
                                <td className="text-right"></td>
                                <td className="text-right"></td>
                                <td className="text-right"></td>
                                <td className="text-right"></td>
                            </tr>
                        </tfoot>}
                </Table>
            </Tab>
            <Tab eventKey="charts" title="Charts"  className="custom-tab-content">
                <div className="row">
                    <div className="col-md-6">
                            <GraphsCard title="KPIs TREND" subTitle="- In Millions">
                                <div className="graph-buttons">
                                    <a onClick={changeMode} className={mode == "investedCapital" ? "pointer active" : "pointer"} data-name="investedCapital">
                                         <div>Invested Capital</div>
                                         <div>{Helpers.formatNumberComma(kpiTrendsLatest?.investedCapital)}</div>
                                    </a>
                                    <a onClick={changeMode}  className={mode == "marketValue" ? "pointer active" : "pointer"}  data-name="marketValue">
                                         <div>Market Value</div>
                                         <div>{Helpers.formatNumberComma(kpiTrendsLatest?.marketValue)}</div>
                                    </a>
                                    <a onClick={changeMode}  className={mode == "valueCreated" ? "pointer active" : "pointer"} data-name="valueCreated">
                                         <div>Value Created</div>
                                         <div>{Helpers.formatNumberComma(kpiTrendsLatest?.valueCreated)}</div>
                                    </a>
                                    <a onClick={changeMode}  className={mode == "totalValue" ? "pointer active" : "pointer"}  data-name="totalValue">
                                         <div>Total Value</div>
                                         <div>{Helpers.formatNumberComma(kpiTrendsLatest?.totalValue)}</div>
                                    </a>
                                    <a onClick={changeMode}  className={mode == "netIrr" ? "pointer active" : "pointer"}  data-name="netIrr">
                                         <div>Net IRR</div>
                                         <div>{Helpers.formatNumberComma(kpiTrendsLatest?.netIrr)}</div>
                                    </a>
                                    
                                </div>
                                <ActionGraph data={kpiTrendsByYear} categories={kpiTrendsYears} />
                            </GraphsCard>
                    </div>
                    <div className="col-md-6">
                            <GraphsCard title="ALLOCATION">
                                <Pie data={pieData} />
                            </GraphsCard>
                    </div>
                  </div>

                  <div className="col-md-12 mt-3">
                        <GraphsCard title="KPIs REGISTER"  subTitle="- In Millions">
                            <div className="row">
                                <div className="col-md-12 custom-legends">
                                    <div className="custom-legend"><div className="tag blue"></div> <b>Invested Capital</b></div>
                                    <div className="custom-legend"><div className="tag maroon"></div> <b>Total Value</b></div>
                                    <div className="custom-legend"><div className="tag brown"></div> <b>Value Added</b></div>
                                    <div className="custom-legend"><div className="tag coffee"></div> <b>Market Value</b></div>
                                </div>
                                {!Helpers.isEmpty(kpRegister) &&
                                    kpRegister.map((list,i)=>(
                                        <div className="col-md-6 multiGraph" key={"card"+i}>
                                            <div className="theme-color"><b>{list?.name}</b> <i className={list?.totalValue > 0 ? "fa fa-caret-up green" : "fa fa-caret-down red"}></i></div>
                                            <MultiBar data={list?.data} key={"multiBar"+i}/>
                                        </div>
                                    ))
                                }
                            </div>
                        </GraphsCard>
                  </div>
                  
            </Tab>
        </TabsComp>
    </div>
    )
}

export default PvtInvestment
